module.exports = __webpack_public_path__ + "static/media/Doc_Icon.04e3f399.svg";